// Textos de las reservas de grupo de Taxi / VTC: pantallas de la empresa
// (listado, detalle, asistente y justificante) y mesa de WAIIS. Se registran
// junto al resto de vocabularios en AppComponent.
export const locale = {
  lang: 'es',
  data: {
    RIDE_BOOKINGS: {
      STATUS: {
        REQUESTING: 'Reservando',
        CANCELLING: 'Cancelando',
        SCHEDULED: 'Programada',
        FAILED: 'Fallida',
        REQUESTED: 'Solicitada',
        CONFIRMED: 'Confirmada',
        IN_PROGRESS: 'En curso',
        COMPLETED: 'Completada',
        CANCELLED: 'Cancelada',
      },
      VEHICLE_STATUS: {
        PENDING: 'En cola',
        REQUESTING: 'Reservando',
        BOOKED: 'Reservado',
        FAILED: 'No reservado',
        NEEDS_ATTENTION: 'Por revisar',
        CANCELLED: 'Cancelado',
      },
      FAILURE_REASON: {
        PRICE_ABOVE_MAX: 'El precio ha subido por encima del máximo',
        PRODUCT_UNAVAILABLE: 'El producto ya no está disponible',
        FARE_EXPIRED: 'La cotización ha caducado',
        SURGE: 'El proveedor aplica tarifa dinámica en ese momento',
        SCHEDULED_AT_OUT_OF_RANGE: 'El proveedor no admite reservar para esa hora',
        PASSENGER_PHONE_MISSING: 'Al titular le falta el teléfono',
        HOLD_FAILED: 'No se ha podido retener el importe',
        PROVIDER_TRIP_FAILED: 'El proveedor no ha confirmado el viaje',
        PROVIDER_TRIP_REJECTED: 'El proveedor ha rechazado el viaje',
        PASSENGER_PHONE_INVALID: 'El teléfono del titular no es válido',
        UNEXPECTED_ERROR: 'Error inesperado',
        ATTEMPT_INTERRUPTED: 'El intento se ha interrumpido',
      },
      HOLD: {
        PENDING: 'Reteniendo el importe',
        HELD: 'Importe retenido',
        FAILED: 'Retención fallida',
      },
      CATEGORY: {
        ECONOMY: 'Económico',
        EXECUTIVE: 'Ejecutivo',
        VAN: 'Van',
      },
      SERVICE: {
        ANY: 'Taxi o VTC',
        TAXI: 'Solo taxi',
        VTC: 'Solo VTC',
      },
      CANCELLED_BY: {
        COMPANY: 'Cancelada por la empresa',
        WAIIS: 'Cancelada por WAIIS',
        SYSTEM: 'Cancelada automáticamente',
      },
      MONEY_REASON: {
        INSUFFICIENT_AVAILABLE_BALANCE: 'No hay saldo suficiente en el wallet de la empresa',
        TOP_UP_FAILED: 'Ha fallado la recarga desde la tarjeta de la empresa',
        ALREADY_SETTLED: 'La reserva ya estaba liquidada',
        ERROR: 'Error inesperado al mover el dinero',
      },
      EVENT: {
        REQUESTED: 'Reserva solicitada',
        HOLD_SUCCEEDED: 'Importe máximo retenido',
        HOLD_FAILED: 'No se ha podido retener el importe',
        CONFIRMED: 'Confirmada por WAIIS',
        VEHICLES_ASSIGNED: 'Vehículos asignados',
        STARTED: 'En curso',
        COMPLETED: 'Completada',
        SETTLED: 'Cobro confirmado',
        SETTLEMENT_FAILED: 'El cobro ha fallado',
        SETTLEMENT_RETRIED: 'Cobro reintentado',
        CANCELLED: 'Cancelada',
        CANCELLATION_REQUESTED: 'Cancelación solicitada',
        CANCELLATION_FAILED: 'No se han podido cancelar todos los viajes',
        RIDE_STARTED: 'Vehículo {{position}}: viaje iniciado',
        RIDE_COMPLETED: 'Vehículo {{position}}: viaje completado',
        RIDE_CANCELLED: 'Vehículo {{position}}: viaje cancelado',
        RIDE_FAILED: 'Vehículo {{position}}: el viaje no ha salido adelante',
        SETTLEMENT_REQUESTED: 'Cobro solicitado',
        UNKNOWN: 'Actualización de la reserva',
        VEHICLE_BOOKED: 'Vehículo {{position}} reservado',
        VEHICLE_ATTEMPT_FAILED: 'Vehículo {{position}}: intento fallido',
        VEHICLE_FAILED: 'Vehículo {{position}} no reservado',
        VEHICLE_NEEDS_ATTENTION: 'Vehículo {{position}} por revisar',
        VEHICLES_RESOLVED: 'Reserva resuelta',
        VEHICLES_RESOLVED_COUNTS: '{{booked}} reservados, {{failed}} fallidos, {{needsAttention}} por revisar',
        REQUESTED_AMOUNT: 'Máximo estimado {{amount}}',
        COMPLETED_AMOUNT: 'Total {{amount}}',
        SETTLED_AMOUNT: '{{amount}} cobrados',
        RETRIED_AMOUNT: 'Se vuelven a cobrar {{amount}}',
        VEHICLES_COUNT: '{{count}} vehículos',
        VEHICLES_COUNT_ONE: '1 vehículo',
        NO_COST: 'Sin coste',
        FEE: 'Coste de cancelación {{amount}}',
        RIDE_AMOUNT: 'Importe {{amount}}',
        SETTLEMENT_AMOUNT: 'Se cobran {{amount}}',
        VEHICLES_NOT_CANCELLED: 'Sin cancelar: vehículo {{positions}}',
      },
      FIELD: {
        PICKUP: 'Recogida',
        CONCEPT: 'Concepto',
        COST_CENTER: 'Centro de coste',
        OFFICE: 'Sede',
        ORIGIN: 'Origen',
        DESTINATION: 'Destino',
        ROUTE: 'Trayecto',
        PASSENGERS: 'Personas',
        VEHICLES: 'Vehículos',
        CATEGORY: 'Tipo de vehículo',
        NOTES: 'Notas internas',
        AMOUNT: 'Importe',
        STATUS: 'Estado',
        CORPORATION: 'Empresa',
        CREATED_BY: 'Creada por',
        DATE: 'Fecha',
      },
      VEHICLES_OF: '{{count}} × {{category}}',
      VEHICLES_BOOKED: '{{booked}} de {{total}} reservados',
      PEOPLE: '{{count}} personas',
      PEOPLE_ONE: '1 persona',
      ESTIMATE_RANGE: '{{min}} – {{max}}',
      RIDE_CANCELLED: 'Cancelado',
      ESTIMATED: 'estimado',
      HELD_MAX: 'máximo retenido',
      NO_COST: 'Sin coste',
      FEE: 'coste de cancelación',
      CHARGE_FAILED: 'Cobro fallido',
      OPEN: 'Abrir',
      RETRY: 'Reintentar',
      PREVIOUS: 'Anterior',
      NEXT: 'Siguiente',
      ACCEPT: 'Aceptar',
      CANCEL: 'Cancelar',
      BACK: 'Volver',
      ALL_STATUSES: 'Todos los estados',
      FROM: 'Desde',
      TO: 'Hasta',
      PAGINATION: 'Mostrando {{shown}} de {{total}} reservas',
      LOAD_ERROR: 'No se han podido cargar las reservas.',
      FORBIDDEN: 'No tienes permiso para ver las reservas de esta empresa.',
      TODAY: 'Hoy',
      TOMORROW: 'Mañana',

      COST_CENTERS: {
        TITLE: 'Centros de coste',
        SUB: 'Para imputar las reservas de grupo. Opcional.',
        ADD: 'Añadir',
        NAME: 'Nombre del centro de coste',
        SAVING: 'Añadiendo…',
        EMPTY: 'Aún no hay centros de coste.',
        DUPLICATE: 'Ya hay un centro de coste con ese nombre.',
        SAVE_ERROR: 'No se ha podido añadir el centro de coste.',
        LOAD_ERROR: 'No se han podido cargar los centros de coste.',
        REMOVE: 'Quitar',
        REMOVE_TITLE: 'Quitar «{{name}}»',
        REMOVE_TEXT: 'Las reservas que ya lo usan conservan su etiqueta.',
        REMOVING: 'Quitando…',
        REMOVED: 'Quitado',
        REMOVE_ERROR: 'No se ha podido quitar el centro de coste',
      },

      QUICK: {
        FAB: 'Reservar taxi',
        TITLE: 'Reserva para un grupo o evento',
        SUB: 'Para salir ahora, el empleado usa la app',
        ORIGIN: 'Origen · sede o dirección',
        DESTINATION: 'Destino',
        CONTINUE: 'Continuar con la reserva',
        NEXT: 'Próxima reserva',
        NONE: 'Ninguna',
        MAP_BOOKING: '{{concept}} · {{when}}',
      },

      KPI: {
        NEXT: 'Próxima reserva',
        NO_NEXT: 'Sin reservas próximas',
        VEHICLES: '{{count}} vehículos',
        VEHICLES_ONE: '1 vehículo',
        PENDING: 'Reservándose o por revisar',
        PENDING_HINT: 'Se están reservando o tienen algún vehículo por revisar',
        ALL_CONFIRMED: 'Todo reservado',
        SPENT: 'Reservas · últimos 30 días',
        COMMITTED: 'Comprometido en próximas: {{amount}}',
      },

      LIST: {
        ALL_OFFICES: 'Todas las sedes',
        TITLE: 'Reservas de grupo',
        NEW: 'Nueva reserva',
        EMPTY_TITLE: 'Aún no hay reservas',
        EMPTY_NONE: 'Crea la primera para un evento, una visita o un grupo.',
        EMPTY_FILTERED: 'Ninguna reserva cumple los filtros.',
        CREATED: 'Reserva creada: estamos reservando los vehículos',
        ACTIONS: 'Acciones',
        DETAILS: 'Detalles',
        EMPTY_FILTERED_TITLE: 'Sin resultados',
      },

      DETAIL: {
        BACK_TO_LIST: 'Volver al listado',
        NOT_FOUND: 'Esta reserva no existe o es de otra empresa.',
        LOAD_ERROR: 'No se ha podido cargar la reserva.',
        PRICE: 'Importe',
        ESTIMATE: 'Precio estimado',
        COMMISSION_INCLUDED: 'Incluye un {{pct}} % de comisión de WAIIS',
        UNKNOWN_PASSENGER: 'Persona que ya no está en la plantilla',
        NO_VEHICLES: 'WAIIS asigna el proveedor y los vehículos al confirmar.',
        VEHICLE: 'Vehículo {{n}}',
        PROVIDER: 'Proveedor',
        DRIVER: 'Conductor',
        PLATE: 'Matrícula',
        VEHICLE_AMOUNT: 'Importe',
        HISTORY: 'Historial',
        PICKUP_FUTURE: 'Recogida',
        RECEIPT: 'Ver justificante',
        CANCEL: 'Cancelar reserva',
        NOTE_HOLD_PENDING_TITLE: 'Reteniendo el importe máximo',
        NOTE_HOLD_PENDING: 'En unos segundos se retiene {{amount}} en el wallet de la empresa. Si no hay saldo, se recarga desde su tarjeta.',
        NOTE_REQUESTED_TITLE: 'Pendiente de que WAIIS la confirme',
        NOTE_REQUESTED: 'Recibirás un correo cuando esté confirmada.',
        NOTE_HOLD_FAILED_TITLE: 'Cancelada: no se ha podido retener el importe',
        NOTE_CANCELLED_BY_WAIIS_TITLE: 'WAIIS ha cancelado la reserva',
        NOTE_CHARGE_FAILED_TITLE: 'El cobro ha fallado',
        NOTE_CHARGE_FAILED: 'WAIIS lo reintentará. Mientras tanto la empresa no puede hacer reservas nuevas ni pagar viajes de empleados.',
        CLOSE: 'Cerrar',
        PRICE_FINAL: 'final · estimado {{range}}',
        PRICE_HELD: 'estimado · retenidos {{amount}}',
        PRICE_TOTAL_HELD: 'total de los viajes · máximo retenido {{amount}}',
        NO_COST_LOWER: 'sin coste',
        VEHICLES_TITLE: 'Vehículos · {{count}} × {{category}} · {{service}}',
        DRIVER_PENDING: 'conductor y matrícula por asignar',
        REPEAT: 'Repetir reserva',
        BOOK_AGAIN: 'Volver a reservar',
        VEHICLES_TITLE_PRODUCT: 'Vehículos · {{count}} × {{product}}',
        TITULAR: 'Titular: {{name}}',
        VEHICLE_ATTEMPTS: '{{count}} intentos',
        VEHICLE_ATTEMPTS_ONE: '1 intento',
        VEHICLE_NEEDS_ATTENTION: 'No se pudo confirmar con el proveedor si el viaje se creó: revísalo en su panel antes de volver a reservar',
        NOTE_REQUESTING_TITLE: 'Estamos reservando los vehículos…',
        NOTE_REQUESTING: 'Esta reserva se actualiza sola mientras tanto.',
        NOTE_FAILED_TITLE: 'No se ha podido reservar ningún vehículo',
        NOTE_FAILED: 'Cada vehículo dice por qué. Puedes volver a reservar.',
      },

      WIZARD: {
        TITLE: 'Nueva reserva',
        SUB: 'Un viaje de Uber, Cabify o Bolt por vehículo, con un empleado como titular. La empresa paga.',
        STEPS_ARIA: 'Pasos de la reserva',
        STEP_TRIP: 'Trayecto',
        STEP_PRODUCT: 'Producto',
        STEP_POINTS: 'Recogida y dejada',
        STEP_PASSENGERS: 'Pasajeros',
        STEP_SUMMARY: 'Confirmar',
        CONCEPT_PLACEHOLDER: 'Cena de equipo, visita de un cliente…',
        CONCEPT_REQUIRED: 'Indica el concepto.',
        ADDRESS_REQUIRED: 'Elige una dirección de la lista.',
        PICKUP_HINT: 'Hora de Madrid.',
        PICKUP_REQUIRED: 'Indica la fecha y la hora de recogida.',
        PICKUP_PAST: 'La recogida tiene que ser en el futuro.',
        PASSENGERS_RANGE: 'Entre 1 y 60 personas.',
        PASSENGERS_COUNT: 'Número de personas',
        PEOPLE_UNIT: 'personas',
        ORIGIN_PLACEHOLDER: 'Sede o dirección',
        DESTINATION_PLACEHOLDER: 'Dirección, aeropuerto, hotel…',
        DATE: 'Fecha',
        TIME: 'Hora de recogida',
        OPTIONAL_LOWER: 'opcional',
        COST_CENTERS_UNAVAILABLE: 'Los centros de coste se añaden en Ajustes.',
        NO_COST_CENTER: 'Sin asignar',
        NO_OFFICE: 'Sin sede',
        QUOTE_ERROR: 'No se ha podido cotizar el trayecto.',
        FARE_EXPIRED: 'La cotización ha caducado: elige de nuevo el producto.',
        PRODUCT_REQUIRED: 'Elige un producto.',
        PRODUCT_VEHICLES: '{{count}} vehículos de {{seats}} plazas',
        PRODUCT_VEHICLES_ONE: '1 vehículo de {{seats}} plazas',
        ETA: 'llega en {{minutes}} min',
        PER_VEHICLE: '{{range}} por vehículo',
        TOTAL: 'Total',
        NO_SCHEDULING: 'No admite reservar con antelación',
        TOO_MANY_VEHICLES: 'Más de {{max}} vehículos: divide el grupo en varias reservas',
        POINTS_PICKUP: 'Recogida',
        POINTS_DROPOFF: 'Dejada',
        ADDRESS_OPTION: 'La dirección elegida',
        POINTS_NONE: 'El proveedor no da puntos aquí: se usa la dirección elegida.',
        MAP_LABEL: 'Mapa del trayecto',
        TITULAR_HINT: 'El primero de cada vehículo es el titular del viaje.',
        ADD_GROUP: 'Añadir un grupo',
        ADD_PEOPLE: 'Añadir personas',
        VEHICLE: 'Vehículo {{n}}',
        SEATS_USED: '{{count}} de {{seats}} plazas',
        TITULAR: 'Titular',
        MAKE_TITULAR: 'Hacer titular',
        TITULAR_NAME: 'Titular: {{name}}',
        IN_VEHICLE: 'En el vehículo {{n}}',
        VEHICLE_EMPTY: 'Añade al menos una persona: la primera es el titular.',
        GROUP_OVERFLOW: '{{count}} personas de {{group}} no caben en los vehículos.',
        GROUP_OVERFLOW_ONE: '1 persona de {{group}} no cabe en los vehículos.',
        REMOVE: 'Quitar',
        SEARCH_PEOPLE: 'Buscar por nombre o departamento…',
        SEARCH_GROUPS: 'Buscar grupo…',
        PEOPLE_NONE: 'No hay nadie con ese nombre.',
        GROUPS_NONE: 'No hay grupos con ese nombre.',
        ESTIMATE: 'Precio estimado',
        COMMISSION: 'Incluye {{pct}} % de comisión de WAIIS',
        HOLD_MAX: 'Se retiene el máximo: {{amount}}',
        SUMMARY: 'Resumen',
        WHEN: 'Cuándo',
        PRODUCT: 'Producto',
        NOTES_PLACEHOLDER: 'Ej.: referencia del evento, persona de contacto…',
        NOTES_HINT: 'Solo las ve tu empresa: no se envían a los conductores.',
        PAYMENT: 'Pago',
        PAY_HOLD: 'Importe máximo a retener',
        PAY_WALLET: 'Wallet de empresa · saldo disponible',
        PAY_TOP_UP: 'Falta saldo · se recarga desde {{card}}',
        PAY_NO_CARD: 'Falta saldo y no hay tarjeta de empresa: la reserva no podrá retenerse.',
        PAY_INSUFFICIENT: 'Falta saldo y la política no tiene recarga automática: la reserva no podrá retenerse.',
        NOT_ALLOWED: {
          FLAG_DISABLED: 'Las reservas de grupo no están activadas para tu empresa.',
          PLAN_LOCKED: 'Tu plan no incluye las reservas de grupo.',
          POLICY_INACTIVE: 'La política de viajes de la empresa no está activa.',
          CORPORATE_DEBT: 'La empresa tiene pagos pendientes: no se puede reservar hasta saldarlos.',
          BUDGET_EXHAUSTED: 'Se ha agotado el presupuesto de viajes de la empresa.',
        },
        CONTINUE: 'Continuar',
        SUBMIT: 'Reservar',
        SUBMITTING: 'Reservando…',
        SUBMIT_ERROR: 'No se ha podido hacer la reserva.',
      },

      CANCEL_DIALOG: {
        TITLE: 'Cancelar la reserva',
        TEXT: '«{{concept}}», con recogida el {{pickup}}.',
        FREE: 'Sin coste: se libera lo retenido ({{amount}}).',
        PROVIDER_POLICY: 'Cada viaje se cancela con la política de su proveedor y puede llevar un coste.',
        LATE: 'Quedan menos de {{hours}} h: cuesta {{amount}} ({{pct}} % del máximo estimado). Se libera el resto.',
        CONFIRM: 'Cancelar reserva',
        SAVING: 'Cancelando…',
        DONE: 'Cancelada',
        ERROR: 'No se ha podido cancelar la reserva',
        NOT_CANCELLABLE_TITLE: 'Esta reserva ya no se puede cancelar',
        NOT_CANCELLABLE_TEXT: 'Ya está en curso o ha terminado.',
        RIDES_FAILED_TITLE: 'No se han podido cancelar todos los viajes',
        RIDES_FAILED_TEXT: 'El proveedor no ha aceptado la cancelación del vehículo {{vehicles}}. La reserva sigue activa con el resto ya cancelado: vuelve a intentarlo.',
      },

      RECEIPT: {
        TITLE: 'Justificante de reserva',
        PRINT: 'Imprimir o guardar en PDF',
        BACK: 'Volver a la reserva',
        NOT_READY: 'El justificante está disponible cuando la reserva se completa.',
        LOAD_ERROR: 'No se ha podido cargar el justificante.',
        ISSUER: 'WAIIS · Justificante de reserva de grupo',
        REFERENCE: 'Referencia',
        COMPLETED_AT: 'Completada el',
        VEHICLE: 'Vehículo',
        SUBTOTAL: 'Importe de los vehículos',
        COMMISSION: 'Comisión de WAIIS ({{pct}} %)',
        TOTAL: 'Total',
        PAYMENT: 'Pago',
        PAYMENT_PAID: 'Cobrado el {{date}}',
        PAYMENT_PENDING: 'Pendiente de cobro',
        PAYMENT_FAILED: 'El cobro ha fallado',
        FOOTER: 'Cargado al wallet de la empresa. WAIIS intermedia la reserva; el transporte lo prestan operadores autorizados.',
      },

      SETTINGS: {
        NOTE_TITLE: 'Reglas de las reservas de grupo',
        NOTE_TEXT: 'Valen para todas las empresas. Las plazas limitan los pasajeros de cada vehículo; la cancelación solo se aplica a las reservas anteriores, que gestionaba WAIIS.',
        LOAD_ERROR: 'No se han podido cargar los ajustes de las reservas.',
        CANCEL_TITLE: 'Cancelación',
        CANCEL_SUB: 'Solo para las reservas anteriores, que gestionaba WAIIS: cuándo deja de ser gratis cancelar una confirmada y cuánto cuesta después.',
        FREE_HOURS: 'Gratis hasta (horas antes)',
        FREE_HOURS_HINT: 'Entre 0 y 720. Una reserva solicitada se cancela siempre gratis.',
        FEE_PERCENT: 'Coste después (% del máximo estimado)',
        FEE_PERCENT_HINT: 'Entre 0 y 100. Solo en las reservas anteriores.',
        SEATS_TITLE: 'Plazas por vehículo',
        SEATS_SUB: 'En un vehículo no caben más pasajeros que las plazas de su categoría.',
        RANGE: 'Fuera de rango.',
        SAVE: 'Guardar cambios',
        SAVING: 'Guardando…',
        SAVED: 'Ajustes de las reservas guardados',
        SAVE_ERROR: 'No se han podido guardar los ajustes',
        ACCEPT: 'Aceptar',
      },

      DESK: {
        TITLE: 'Reservas de grupo',
        SUB: 'Todas las reservas de las empresas, de la más próxima a la más lejana. Los vehículos se reservan solos; desde aquí se ven y se cancelan con motivo.',
        ALL_CORPORATIONS: 'Todas las empresas',
        CORPORATION_ARIA: 'Empresa',
        EMPTY: 'No hay reservas con estos filtros.',
        CANCEL: 'Cancelar',
        CANCEL_TITLE: 'Cancelar la reserva',
        CANCEL_TEXT: 'Se libera lo retenido salvo lo que cobren los proveedores por cancelar, y se avisa a quien la creó con el motivo.',
        CANCEL_REASON: 'Motivo (lo verá la empresa)',
        CANCEL_REASON_REQUIRED: 'Escribe el motivo.',
        CANCEL_DONE: 'Cancelada',
        CANCEL_SAVING: 'Cancelando…',
        ACTION_ERROR: 'No se ha podido completar la acción',
      },
      DESK_DETAIL: {
        BOOKING_ID: 'Id de la reserva',
        COPY_ID: 'Copiar id',
        ID_COPIED: 'Copiado',
        PICKUP_META: 'Recogida {{date}}',
        OFFICE_META: 'Sede {{name}}',
        CREATED_BY_META: 'Creada por {{name}}',
        SECTION: {
          BOOKING: 'Reserva',
          ROUTE: 'Trayecto',
          AMOUNT: 'Importe',
          VEHICLES: 'Vehículos',
          HISTORY: 'Historial',
        },
        SECTION_SUB: {
          BOOKING: 'Qué se ha reservado, para cuándo y quién la ha pedido.',
          ROUTE: 'Dónde se recoge al grupo y adónde va.',
          AMOUNT: 'Lo estimado, lo retenido en el wallet de la empresa y lo cobrado.',
          VEHICLES: '{{count}} × {{category}} · {{service}}',
          VEHICLES_PRODUCT: '{{count}} × {{product}}',
          HISTORY: 'Lo que ha pasado con la reserva, en orden.',
        },
        CREATED_AT: 'Creada el',
        ESTIMATE: 'Estimado',
        HELD: 'Retenido',
        HELD_MAX: 'Máximo retenido',
        COMMISSION: 'Comisión de WAIIS',
        COMMISSION_PCT: '{{pct}} %',
        VEHICLES_AMOUNT: 'Importe de los vehículos',
        TOTAL: 'Total',
        CHARGED: 'Cobrado',
        CHARGED_AT: 'el {{date}}',
        CANCEL_FEE: 'Coste de cancelación',
        VEHICLE_AMOUNT: 'Importe {{amount}}',
      },
    },
  },
};
